import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { useLoader } from "../contexts/LoaderContext";
import Spinner from "../components/spinner/Spinner";

function withAuth(Component) {
  return function EnhancedComponent(props) {
    const { user } = useAuth();
    const { loading } = useLoader();
    if (loading) return <Spinner />;

    if (user?.accessToken) {
      return <Component {...props} />;
    }

    return <Navigate to="/" />;
  };
}

export default withAuth;
